/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Too Many Requests problems.
 */
export type TooManyRequestsProblems = Truvity.TooManyRequestsProblems.TooManyRequests;

export namespace TooManyRequestsProblems {
    export interface TooManyRequests extends Truvity.ProblemTooManyRequests {
        type: '/too-many-requests';
    }
}
